if (!customElements.get('mbs-brands')) {
  customElements.define('mbs-brands', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const on = (el, type, fn) => el.addEventListener(type, fn, {signal:this.abort.signal});
      const list = this.querySelector('.mbsbr__list');
      const prev = this.querySelector('.mbsbr__arrow--prev');
      const next = this.querySelector('.mbsbr__arrow--next');
      if (!list || !prev || !next) return;
      const update = () => {
        prev.hidden = list.scrollLeft <= 2;
        next.hidden = list.scrollLeft >= list.scrollWidth - list.clientWidth - 2;
      };
      const move = direction => {
        const items = [...list.children];
        const step = items[1] ? items[1].offsetLeft - items[0].offsetLeft : list.clientWidth;
        const count = Math.max(1, Math.round(list.clientWidth / step));
        list.scrollBy({left:direction * step * count,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      on(prev,'click',()=>move(-1));
      on(next,'click',()=>move(1));
      on(list,'scroll',update);
      on(list,'keydown',e=>{
        if(e.target !== list) return;
        if(e.key === 'ArrowRight' || e.key === 'ArrowLeft'){e.preventDefault();move(e.key === 'ArrowRight' ? 1 : -1);}
      });
      on(this,'shopify:block:select',e=>e.target.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'}));
      this.resize = new ResizeObserver(update);
      this.resize.observe(list);
      update();
    }
    disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();}
  });
}
